import React from 'react';
import {
  CheckBoxGroup,
  CheckBoxInput,
  CurrencyInput,
  CustomHtml,
  DataListInput,
  DropDownInput,
  FileUploader,
  MultiTextInput,
  NumberInput,
  RadioInputGroup,
  RadioScore,
  RadioScoreTotal,
  TableInput,
  TextInput
} from '../components';
import BlockSelectInput from '../components/BlockSelectInput';
import CustomField from '../components/CustomField';
import FileWithCheck from '../components/FileWithCheck';
import FormGeneratorButton from '../components/FormGeneratorButton';
import MultiSelectDropDown from '../components/MultiSelectDropDown';
import PercentageInput from '../components/PercentageInput';
import SwitchInput from '../components/SwitchInput';

export const mapFieldToElement = field => {
  switch (field.type) {
    case 'table-input': {
      return <TableInput {...field} />;
    }
    case 'text': {
      return <TextInput {...field} />;
    }
    case 'text-area': {
      return <TextInput {...field} textArea={true} />;
    }
    case 'number': {
      return <NumberInput {...field} />;
    }
    case 'currency': {
      return <CurrencyInput {...field} />;
    }
    case 'percentage': {
      return <PercentageInput {...field} />;
    }
    case 'multi-text': {
      return <MultiTextInput {...field} />;
    }
    case 'multi-text-area': {
      return <MultiTextInput {...field} textArea={true} />;
    }
    case 'radio': {
      return <RadioInputGroup {...field} />;
    }
    case 'radio-score': {
      return <RadioScore {...field} />;
    }
    case 'radio-score-grand-total': {
      return <RadioScoreTotal {...field} />;
    }
    case 'checkbox': {
      return <CheckBoxInput {...field} />;
    }
    case 'switch': {
      return <SwitchInput {...field} />;
    }
    case 'checkbox-group': {
      return <CheckBoxGroup {...field} />;
    }
    case 'custom-html': {
      return <CustomHtml {...field} />;
    }
    case 'dropdown': {
      return <DropDownInput {...field} />;
    }
    case 'file': {
      return <FileUploader {...field} />;
    }
    case 'file-with-check': {
      return <FileWithCheck {...field} />;
    }
    case 'datalist-text': {
      return <DataListInput {...field} />;
    }
    case 'block-select': {
      return <BlockSelectInput {...field} />;
    }
    case 'multiselect-dropdown': {
      return <MultiSelectDropDown {...field} />;
    }
    case 'button': {
      return <FormGeneratorButton {...field} />;
    }
    case 'custom': {
      return <CustomField {...field} />;
    }
  }
  return '';
};
